import produce from 'immer';

import {
  HIDE_NAV_BAR,
  SHOW_NAV_BAR,
  NAV_BAR_HOME,
  NAV_BAR_STORY,
  NAV_BAR_PRINT_STORE,
  NAV_BAR_MODAL,
  NAV_BAR_FEED,
  OPEN_STORY,
  CLOSE_STORY,
  SHOW_TERMS,
  SHOW_HOME
} from 'shared/actions/types';

const initialState = {
  nav: {
    hidden: false,
    state: NAV_BAR_HOME,
    homestate: SHOW_HOME,
    url: ''
  }
}

export default function (state = initialState, action) {
  switch (action.type) {
    case HIDE_NAV_BAR:
      return produce(state, draft => {
        draft.nav.hidden = true
      });

    case SHOW_NAV_BAR:
      return produce(state, draft => {
        draft.nav.hidden = false
      });

    case NAV_BAR_HOME:
    case CLOSE_STORY:
      return produce(state, draft => {
        draft.nav.state = NAV_BAR_HOME
      });

    case NAV_BAR_STORY:
    case OPEN_STORY:
      return produce(state, draft => {
        draft.nav.state = NAV_BAR_STORY
      });

    case NAV_BAR_PRINT_STORE:
      return produce(state, draft => {
        draft.nav.state = NAV_BAR_PRINT_STORE
      });

    case NAV_BAR_MODAL:
      return produce(state, draft => {
        draft.nav.state = NAV_BAR_MODAL
      });

    case NAV_BAR_FEED:
      return produce(state, draft => {
        draft.nav.state = NAV_BAR_FEED
      });

    case SHOW_TERMS:
      return produce(state, draft => {
        draft.nav.homestate = SHOW_TERMS;
        draft.nav.url = action.payload
      });

    case SHOW_HOME:
      return produce(state, draft => {
        draft.nav.homestate = SHOW_HOME;
      });

    default:
      return state;
  }
}

